import React, { useEffect, useState } from 'react';
import { Grid, Card, Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from 'react-redux';
import { TraerTopesMinimos, fetchTopesPorNombreResolucion, ModificarTopes, AgregarTopes, EliminarTopes } from "../../../actions/abm/abmTopesMinimos";
import ModalAbm from '../../compartidos/abms/ModalAbm';
import BuscadorAbm from "../../compartidos/abms/BuscadorAbm";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import AccionesGenericoAbm from "../../compartidos/abms/AccionesGenericoAbm";
import moment from "moment";
import { FormTopes } from "../topesMinimosABM/FormTopes"
import {TOPES_MINIMOS_PERMISOS} from "../../../utils/permisos";
const useStyles = makeStyles({
  botonera: {
    padding: 25
  }
});

export const TopesAbmScreen = (props) => {
  const { items } = useSelector((state) => state.topesMinimos);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [topesMinimos, setTopesMinimos] = useState(false);
  const [openAlta, setTopesMinimosAlta] = useState(false);

  useEffect(() => {
    dispatch(TraerTopesMinimos());
  }, [dispatch]);

  const handleSearch = (texto) => {
    dispatch(fetchTopesPorNombreResolucion(texto));
  }

  const handleTopesSelect = (item) => {
    setTopesMinimos(item)
    setOpen(true)
  }
  const handleSave = (item) => {
    if(item.idTope){
      dispatch(ModificarTopes(item.nombreResolucion,item.periodoDesde, item.periodoHasta, item.importe, item.importeMinimo, item.idTope));
    }else{
      dispatch(AgregarTopes(item.periodoDesde, item.periodoHasta, item.importe, item.importeMinimo, item.nombreResolucion));
    }
  }

  const handleDelete=(item)=>{
    dispatch(EliminarTopes(item.idTope));
  }
  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Agregar Tope" open={openAlta} setOpen={setTopesMinimosAlta}>
          <FormTopes topesMinimos={null} handleSave={handleSave} cerrarModal={() => setTopesMinimosAlta(false)} />
        </ModalAbm>
        <ModalAbm title="Modificar Tope" open={open} setOpen={setOpen}>
          <FormTopes topesMinimos={topesMinimos} handleSave={handleSave} cerrarModal={() => setOpen(false)} />
        </ModalAbm>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setTopesMinimosAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Tope Minimo</Button>
        </Grid>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar Topes" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
          <Card>
              <TableGeneric
                data={items}
              columns = {[
                {
                  label:"",
                  customBody:(item) => (
                    <AccionesGenericoAbm
                    item={item}
                    handleItemSelect={handleTopesSelect}
                    permisoDelete={TOPES_MINIMOS_PERMISOS.BAJA}
                    handleDelete={handleDelete}
                    />
                  )
                },
                {
                  label: "Nombre Resolucion",
                  id: "nombreResolucion",
                  sort: true
                },
                {
                  label: "Periodo Desde",
                  id: "periodoDesde",
                  customBody: (item) => moment(`${item.periodoDesde}`, 'YYYYMM').format("MM/YYYY"),
                  sort: true
                },
                {
                  label: "Periodo Hasta",
                  id: "periodoHasta",
                  customBody: (item) => moment(`${item.periodoHasta}`, 'YYYYMM').format("MM/YYYY"),
                  sort: false
                },
                {
                  label: "Importe Min.",
                  id: "importeMinimo",
                  sort: false
                },
                {
                  label: "Importe Max.",
                  id: "importe",
                  sort: false
                }

              ]}
              />
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};
export default TopesAbmScreen; 